import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';

@Component({
  selector: 'app-addMemoryCardTempCategory',
  templateUrl: './addMemoryCardTempCategory.component.html',
  styleUrls: ['./addMemoryCardTempCategory.component.scss']
})
export class AddMemoryCardTempCategoryComponent implements OnInit {
  organizationId: string="";
  databaseId: string="";
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  categoryType: number=0;
  isClinical: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddMemoryCardTempCategoryComponent>,
    private formBuilder: FormBuilder,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,
    private coreService: CoreService,
    private toastr: ToastrService,
    private statusConstant: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any) {  
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice === true) {
        this.myOfficeID = oe.officeID;
      }
    });
  }

  ngOnInit(): void {
    let addcategoryname = {};
    this.formDialog = new FormGroup(addcategoryname);
    this.formDialog.addControl('categoryName', this.formBuilder.control(''));
    this.categoryType = this.data.categoryType;   
  }

  AddCategoryName(data: any) {
    let ReqModel = {
      categoryName: data.categoryName,
      type: Number(this.categoryType),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID:Number(this.databaseId)
    };
    this.spinner = true;
    this.formDialog.markAsPristine();
    this.coreService.addMemoryCardCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.formDialog.reset();
          this.dialogRef.close(data.categoryName);
          this.toastr.success('Category added successfully.', '', {
            timeOut: 2000,
          });
        } else {
          this.spinner = false;
          this.toastr.warning('Category already exist.', '', {
            timeOut: 2000,
          });
        }
      } else {
        this.spinner = false;
      }
    });

   
  }

  

  closeAddCategory() {
    this.formDialog.reset();
    this.dialogRef.close();
  }
}
